var map = {
	"./4a3c495d_08-crop-6d7811.jpg": 7698,
	"./Appreciation Certificate by FSSAI.jpeg": 59659,
	"./Appreciation Certificate by Honorable MLC.jpeg": 95991,
	"./Appreciation Certificate by Honorable MP.jpeg": 42610,
	"./Appreciation Certificate by Honorable MP2.jpeg": 9276,
	"./Appreciation Certificate by Honorable Mayor.png": 15624,
	"./Appreciation Certificate by Honorable VMRDA Chairperson.jpeg": 67527,
	"./Appreciation Certificate by Legal Metrology Department.jpeg": 27582,
	"./Appreciation Certificate by MLA.jpeg": 2049,
	"./Appreciation Certificate by MLA2.jpeg": 75401,
	"./Surya.jpeg": 98332,
	"./Vijayabhanu.jpeg": 32730,
	"./Vision.jpeg": 73532,
	"./WhatsApp Image 2025-03-13 at 8.07.33 PM.jpeg": 11720,
	"./WhatsApp Image 2025-03-13 at 8.52.43 PM.jpeg": 22783,
	"./WhatsApp Image 2025-03-14 at 8.07.11 AM.jpeg": 2096,
	"./WhatsApp Image 2025-03-14 at 8.18.39 AM.jpeg": 90274,
	"./WhatsApp Image 2025-03-15 at 7.28.24 AM.jpeg": 83195,
	"./WhatsApp Image 2025-03-17 at 6.22.53 PM.jpeg": 30001,
	"./WhatsApp Image 2025-03-26 at 10.51.49 PM.jpeg": 80579,
	"./WhatsApp Image 2025-03-26 at 10.52.23 PM.jpeg": 38026,
	"./WhatsApp Image 2025-03-26 at 6.25.09 PM.jpeg": 15649,
	"./WhatsApp Image 2025-03-26 at 7.20.28 PM.jpeg": 78936,
	"./WhatsApp Image 2025-03-26 at 7.21.52 PM.jpeg": 15216,
	"./WhatsApp Image 2025-03-26 at 7.57.11 PM.jpeg": 60962,
	"./WhatsApp Image 2025-03-26 at 9.42.37 PM.jpeg": 80866,
	"./WhatsApp Image 2025-03-27 at 10.26.28 AM.jpeg": 45162,
	"./WhatsApp Image 2025-03-27 at 11.02.09 AM.jpeg": 42242,
	"./WhatsApp Image 2025-03-27 at 5.03.58 PM.jpeg": 43119,
	"./WhatsApp Image 2025-03-27 at 6.36.42 PM.jpeg": 4281,
	"./WhatsApp Image 2025-03-27 at 7.29.12 PM.jpeg": 14183,
	"./WhatsApp Image 2025-03-27 at 7.34.27 AM (1).jpeg": 9110,
	"./WhatsApp Image 2025-03-27 at 7.34.27 AM.jpeg": 32604,
	"./WhatsApp Image 2025-03-27 at 7.55.41 AM.jpeg": 32445,
	"./WhatsApp Image 2025-03-27 at 7.58.07 PM.jpeg": 24937,
	"./WhatsApp Image 2025-03-27 at 8.00.47 AM.jpeg": 18718,
	"./WhatsApp Image 2025-03-27 at 8.01.23 AM (1).jpeg": 17985,
	"./WhatsApp Image 2025-03-27 at 8.01.23 AM.jpeg": 36379,
	"./WhatsApp Image 2025-03-27 at 8.10.27 AM.jpeg": 60665,
	"./WhatsApp Image 2025-03-27 at 8.16.33 PM.jpeg": 59833,
	"./WhatsApp Image 2025-03-27 at 8.25.30 AM.jpeg": 6465,
	"./WhatsApp Image 2025-03-27 at 8.26.00 AM.jpeg": 46245,
	"./WhatsApp Image 2025-03-27 at 8.40.24 AM.jpeg": 10067,
	"./WhatsApp Image 2025-03-27 at 8.51.03 PM.jpeg": 9637,
	"./WhatsApp Image 2025-03-27 at 8.56.42 AM.jpeg": 94892,
	"./WhatsApp Image 2025-03-27 at 9.18.16 AM.jpeg": 7364,
	"./WhatsApp Image 2025-03-27 at 9.19.09 AM.jpeg": 82067,
	"./WhatsApp Image 2025-03-27 at 9.27.34 AM.jpeg": 65534,
	"./WhatsApp Image 2025-03-27 at 9.35.44 AM.jpeg": 87660,
	"./WhatsApp Image 2025-04-19 at 8.42.13 AM.jpeg": 57021,
	"./WhatsApp Image 2025-04-19 at 8.42.17 AM.jpeg": 27641,
	"./WhatsApp Image 2025-04-19 at 8.42.18 AM.jpeg": 66810,
	"./WhatsApp Image 2025-04-19 at 8.42.19 AM (1).jpeg": 21461,
	"./WhatsApp Image 2025-04-19 at 8.42.21 AM (1).jpeg": 76964,
	"./WhatsApp Image 2025-04-21 at 9.54.15 PM.jpeg": 4795,
	"./WhatsApp Image 2025-04-22 at 7.56.29 AM.jpeg": 68074,
	"./WhatsApp Image 2025-10-31 at 9.35.23 PM (1).jpeg": 89657,
	"./WhatsApp Image 2025-10-31 at 9.35.25 PM (1).jpeg": 32659,
	"./WhatsApp Image 2025-10-31 at 9.35.25 PM.jpeg": 2157,
	"./WhatsApp Image 2025-10-31 at 9.35.26 PM (1).jpeg": 51516,
	"./WhatsApp Image 2025-10-31 at 9.35.26 PM.jpeg": 60898,
	"./WhatsApp Image 2025-10-31 at 9.35.27 PM.jpeg": 22839,
	"./WhatsApp Image 2025-10-31 at 9.35.28 PM.jpeg": 39348,
	"./WhatsApp Image 2025-10-31 at 9.35.29 PM.jpeg": 57809,
	"./WhatsApp Image 2025-10-31 at 9.35.32 PM.jpeg": 87481,
	"./WhatsApp Image 2025-10-31 at 9.35.34 PM.jpeg": 9479,
	"./WhatsApp Image 2025-10-31 at 9.35.35 PM.jpeg": 65074,
	"./WhatsApp Image 2025-10-31 at 9.35.36 PM (1).jpeg": 65379,
	"./WhatsApp Image 2025-10-31 at 9.35.36 PM.jpeg": 7837,
	"./WhatsApp Image 2025-10-31 at 9.35.37 PM (1).jpeg": 938,
	"./WhatsApp Image 2025-10-31 at 9.35.37 PM.jpeg": 28848,
	"./WhatsApp Image 2025-10-31 at 9.35.38 PM (1).jpeg": 28017,
	"./WhatsApp Image 2025-10-31 at 9.35.38 PM.jpeg": 65771,
	"./WhatsApp Image 2025-10-31 at 9.35.39 PM (1).jpeg": 71904,
	"./WhatsApp Image 2025-10-31 at 9.35.39 PM (2).jpeg": 86527,
	"./WhatsApp Image 2025-10-31 at 9.35.39 PM.jpeg": 75366,
	"./WhatsApp Image 2025-10-31 at 9.35.40 PM (1).jpeg": 78700,
	"./WhatsApp Image 2025-10-31 at 9.35.40 PM.jpeg": 47698,
	"./WhatsApp Image 2025-10-31 at 9.35.41 PM (1).jpeg": 70973,
	"./WhatsApp Image 2025-10-31 at 9.35.41 PM.jpeg": 92103,
	"./WhatsApp Image 2025-10-31 at 9.35.42 PM (1).jpeg": 22826,
	"./WhatsApp Image 2025-10-31 at 9.35.42 PM.jpeg": 11472,
	"./WhatsApp Image 2025-10-31 at 9.35.44 PM.jpeg": 78782,
	"./WhatsApp Image 2025-10-31 at 9.35.46 PM.jpeg": 27996,
	"./WhatsApp Image 2025-10-31 at 9.35.48 PM (1).jpeg": 89844,
	"./WhatsApp Image 2025-10-31 at 9.35.48 PM.jpeg": 46138,
	"./abfdb2e8_07-crop-9f408b.jpg": 20520,
	"./parking1.jpeg": 12787,
	"./parking2.jpeg": 13222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94600;